import { c as _c } from "react/compiler-runtime";
import type { ColumnPinningState, HeaderGroup } from '@tanstack/react-table';
import type { ChartCardTFunction, ChartDataRow, ChartCardDefaults } from '../../../types';
import type { ReactElement } from 'react';
import type { ElementsDescriptionsMap, TotalsAndRangeData } from '../../../internalTypes';
import { styled } from '@precis-digital/kurama/utils';
import { TableRow } from '@precis-digital/kurama/Table';
import TableFooterCell from './TableFooterCell';
import { useHovered } from '../hooks';
import { useChartCardDefaults } from '../../../hooks/useChartCardDefaults';
import { getPinPositionForColumnId } from '../utils';
interface TableFooterRowProps<DataKey extends string, DataRow extends ChartDataRow<DataKey>> {
  footerGroup: HeaderGroup<DataRow>;
  columnPinning: ColumnPinningState;
  elementsDescriptionsMap: ElementsDescriptionsMap<DataKey>;
  allowColumnResizing: boolean;
  totalsData: TotalsAndRangeData<DataKey>['totals'];
  preferTotalsData?: boolean;
  t: ChartCardTFunction;
}
const TableFooterRow = t0 => {
  const $ = _c(24);
  const {
    footerGroup: t1,
    columnPinning,
    elementsDescriptionsMap,
    allowColumnResizing,
    totalsData,
    preferTotalsData: t2,
    t
  } = t0;
  const {
    id: groupId,
    headers
  } = t1;
  const preferTotalsData = t2 === undefined ? false : t2;
  const defaults = useChartCardDefaults();
  const {
    hovered,
    onMouseEnter,
    onMouseLeave
  } = useHovered();
  let t3;
  if ($[0] !== allowColumnResizing || $[1] !== columnPinning || $[2] !== elementsDescriptionsMap || $[3] !== headers || $[4] !== hovered || $[5] !== preferTotalsData || $[6] !== t || $[7] !== totalsData) {
    let t4;
    if ($[9] !== allowColumnResizing || $[10] !== columnPinning || $[11] !== elementsDescriptionsMap || $[12] !== hovered || $[13] !== preferTotalsData || $[14] !== t || $[15] !== totalsData) {
      t4 = header => {
        const pinned = getPinPositionForColumnId(columnPinning, header.column.id);
        return <TableFooterCell key={header.id} header={header} pinned={pinned} elementsDescriptionsMap={elementsDescriptionsMap} allowColumnResizing={allowColumnResizing} totalsData={totalsData} preferTotalsData={preferTotalsData} rowHovered={hovered} t={t} />;
      };
      $[9] = allowColumnResizing;
      $[10] = columnPinning;
      $[11] = elementsDescriptionsMap;
      $[12] = hovered;
      $[13] = preferTotalsData;
      $[14] = t;
      $[15] = totalsData;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    t3 = headers.map(t4);
    $[0] = allowColumnResizing;
    $[1] = columnPinning;
    $[2] = elementsDescriptionsMap;
    $[3] = headers;
    $[4] = hovered;
    $[5] = preferTotalsData;
    $[6] = t;
    $[7] = totalsData;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[17] !== defaults || $[18] !== groupId || $[19] !== hovered || $[20] !== onMouseEnter || $[21] !== onMouseLeave || $[22] !== t3) {
    t4 = <StyledTableFooterRow key={groupId} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} hovered={hovered} defaults={defaults}>{t3}</StyledTableFooterRow>;
    $[17] = defaults;
    $[18] = groupId;
    $[19] = hovered;
    $[20] = onMouseEnter;
    $[21] = onMouseLeave;
    $[22] = t3;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
};
const StyledTableFooterRow = styled(TableRow, {
  shouldForwardProp: prop => prop !== 'hovered' && prop !== 'defaults'
})<{
  hovered: boolean;
  defaults: ChartCardDefaults;
}>(({
  hovered,
  defaults
}) => ({
  display: 'flex',
  width: '100%',
  backgroundColor: hovered ? defaults.table.hoverBackgroundColor.footer ?? defaults.table.backgroundColor.footer : defaults.table.backgroundColor.footer
}));
export default TableFooterRow;